// Handlebars AMD is dependant on some features built into requirejs
// that aren't in modulizr. This file adds those features.

// module is not defined in modulizr, it is safe to just
// return a generic object
// define('jquery', function() { return $});
if(!require('module')) {
    try {
        define('module', function() {return {}});
        define('exports', function() {return {}});

    // requirejs handles paths to files while modulizr does not
    // we point the paths handlebars expects at the objects
        define('./utils', ['handlebars/utils'], function(utils) { return utils});
        define('./handlebars/utils', ['handlebars/utils'], function(utils) { return utils});
        define('./exception', ['handlebars/exception'], function(exception) { return exception});
        define('./handlebars/exception', ['handlebars/exception'], function(exception) { return exception});
        define('./safe-string', ['handlebars/safe-string'], function(safeString) { return safeString});
        define('./handlebars/safe-string', ['handlebars/safe-string'], function(safeString) { return safeString});
        define('./base', ['handlebars/base'], function(base) { return base});
        define('./handlebars/base', ['handlebars/base'], function(base) { return base});
        define('./no-conflict', ['handlebars/no-conflict'], function(noConflict) { return noConflict});
        define('./handlebars/no-conflict', ['handlebars/no-conflict'], function(noConflict) { return noConflict});
        define('./runtime', ['handlebars/runtime'], function(runtime) { return runtime});
        define('./handlebars/runtime', ['handlebars/runtime'], function(runtime) { return runtime});

    } catch (e) { }
}